export default __webpack_public_path__ + "static/linea3-preview-1-arg-e1a3c19f81d2fb5786276403755dd87f.png";